import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";



export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  //////////////////////////forgot password/////////////
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  const [resetStatus, setResetStatus] = useState("");

  /////////////////////


  const API_URL = process.env.REACT_APP_API_URL;
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      const res = await axios.post(`${API_URL}/login`, {
        username,
        password
      });

      login(res.data.token, res.data.user);

    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          setMsg("Invalid username or password");
        }
        else if (err.response.status === 403) {
          setMsg("Your account is inactive. Contact admin.");
        }
        else {
          setMsg(err.response.data?.messages?.error || "Login failed");
        }
      } else {
        setMsg("Server error, please try again later");
      }
    }
  };

  ///////////////////////////////////api mail matching//////////////


  const handleResetPassword = async () => {
    if (!resetEmail) {
      setResetStatus("error");
      setResetMsg("Please enter a valid email address");
      return;
    }

    setResetStatus("loading");
    setResetMsg("Sending reset link...");

    try {
      const res = await axios.post(`${API_URL}/forgot-password`, {
        email: resetEmail,
      });

      if (res.data?.status === true) {
        setResetStatus("success");
        setResetMsg("✔ Reset link sent to your email");
        setResetEmail("");
      } else {
        setResetStatus("error");
        setResetMsg("✖ Unable to send reset link");
      }
    } catch (err) {
      setResetStatus("error");
      setResetMsg("✖ Please enter a valid email ID");
    }
  };

  /////////////////////////////////////////////////////////
  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        background: "linear-gradient(135deg, #007bff 0%, #6610f2 100%)",
      }}
    >
      <div className="card shadow-lg p-4" style={{ width: "100%", maxWidth: "400px", borderRadius: "15px" }}>
        <div className="text-center mb-4">
          <img src="/favicon.ico" alt="User Icon" width="70" className="mb-3" />
          <h3 className="fw-bold">Welcome Back</h3>
          <p className="text-muted">Login to your account</p>
        </div>

        {msg && <div className="alert alert-danger text-center">{msg}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Username</label>
            <input
              className="form-control"
              placeholder="Enter your username"
              autoComplete="off"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              className="form-control"
              placeholder="Enter your password"
              autoComplete="off"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100 fw-bold" style={{ borderRadius: "25px" }}>
            Login
          </button>
        </form>

        <div className="text-center mt-4">
          <small className="text-muted">
            Forgot password? <span
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => setShowReset(true)}
            >
              Reset Password
            </span>
          </small>
        </div>
      </div>
      {/* //////////////////////////////start//////////////////// */}
      {showReset && (
        <>
          {/* Backdrop */}
          <div className="modal-backdrop fade show"></div>

          {/* Modal */}
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ zIndex: 1055 }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">Reset Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowReset(false);
                      setResetMsg("");
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  {resetMsg && (
                    <div className="alert alert-info text-center">
                      {resetMsg}
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label"><small>Forgot your password? You can reset it using your email.</small></label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your registered email"
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowReset(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleResetPassword}
                  >
                    submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* //////////////////////////////end//////////////////// */}


    </div>
  );
}
